import { Alert } from '@mui/material';

import { getExperteName } from '../../../../../utils';
import { CalendarExperteResource } from '../../../ResourceCalendar';
import { content } from '../VeranstaltungRessourcenCalendar.content';

type WarningKeineGueltigkeitenProps = Readonly<{
  experteResources: CalendarExperteResource[];
  veranstaltungstypSapId: number;
}>;

export const WarningKeineGueltigkeiten = ({
  experteResources,
  veranstaltungstypSapId,
}: WarningKeineGueltigkeitenProps) => {
  const expertenWithoutGueltigkeiten = experteResources
    .filter((exp) => exp.hasMissingGueltigkeiten())
    .map((exp) => getExperteName(exp.experte));

  if (expertenWithoutGueltigkeiten.length === 0) {
    return null;
  }

  return (
    <Alert severity="warning">
      {content.warnungen.keineGueltigkeiten(expertenWithoutGueltigkeiten, veranstaltungstypSapId)}
    </Alert>
  );
};
